const SITE_NAME = 'MY-SMI®'

export default function setPageTitle(title) {
  document.title = title ? `${title} | ${SITE_NAME}` : SITE_NAME
}
